/* AZUÈ — Processo: accende gli step quando entrano nello schermo.
   - Mobile (<=599px): ogni step si accende quando, scrollando, lo raggiungi.
   - Desktop: quando la sezione entra in vista, cascata temporizzata 01 -> 06.
   Entrambi usano lo stesso stato finale (.is-lit). Affidabile anche se la
   pagina viene caricata/aggiornata con la sezione già in vista.
   Progressive enhancement: senza JS gli step restano colorati. */
(function () {
  var grids = document.querySelectorAll('.azue-process__grid');
  if (!grids.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 599px)').matches;

  grids.forEach(function (grid) {
    // Attiva lo stato "spento" solo ora che il JS è presente
    grid.classList.add('azue-process__grid--anim');

    var steps = grid.querySelectorAll('.azue-step');

    // Fallback: niente animazione -> tutto acceso
    if (reduce || !('IntersectionObserver' in window)) {
      steps.forEach(function (step) { step.classList.add('is-lit'); });
      return;
    }

    if (isMobile) {
      // Mobile: ogni step si illumina quando raggiunge ~il 60% dell'altezza schermo
      var stepObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-lit');
            stepObserver.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });

      steps.forEach(function (step) { stepObserver.observe(step); });
      return;
    }

    // Desktop: quando la sezione entra in vista, accendi gli step uno alla volta
    // (cascata temporizzata dal JS, non dal CSS) -> sempre fluida e affidabile.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          io.disconnect();
          steps.forEach(function (step, i) {
            setTimeout(function () { step.classList.add('is-lit'); }, i * 380);
          });
        }
      });
    }, { threshold: 0.25 });

    io.observe(grid);
  });
})();
